










import { openEdit } from '@/main/router/routerPath';
import { NAME } from '@/modules/kartoteka/partner/constants';
import { PageMode } from '@/main/utils/pageMode';
import Vue from 'vue';

export default Vue.extend({
	name: 'AresDialog',
	props: {
		visible: { type: Boolean, required: true },
		zakaznikTyp: { type: Number, required: true },
	},
	computed: {
		zakaznikTypCmp: {
			get(): number {
				return this.zakaznikTyp;
			},
			set(val: number) {
				this.$emit('update:zakaznikTyp', val);
			},
		},
	},
	methods: {
		async openCreate() {
			this.$emit('cancel-clicked');
			await openEdit(NAME, PageMode.CREATE, { props: true, filter: { PartnertypPzn: this.zakaznikTyp } });
		},
	},
});
